import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function useGsap() {
    if(!import.meta.server) {
        gsap.registerPlugin(
            ScrollTrigger,
        )
    }

    return { gsap }
}